import React from 'react';

export const Email: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00003 18C5.58753 18 5.23441 17.8531 4.94066 17.5594C4.64691 17.2656 4.50003 16.9125 4.50003 16.5V7.50002C4.50003 7.08752 4.64691 6.73439 4.94066 6.44064C5.23441 6.14689 5.58753 6.00002 6.00003 6.00002H18C18.4125 6.00002 18.7657 6.14689 19.0594 6.44064C19.3532 6.73439 19.5 7.08752 19.5 7.50002V16.5C19.5 16.9125 19.3532 17.2656 19.0594 17.5594C18.7657 17.8531 18.4125 18 18 18H6.00003ZM12 12.75L18 9.00002V7.50002L12 11.25L6.00003 7.50002V9.00002L12 12.75Z"
      fill="currentColor"
    />
  </svg>
);
